import addReadWriteRecipients from './addReadWriteRecipients';
import processGetGroupInfoResult from './processGetGroupInfoResult';
import removeReadWriteRecipients from './removeReadWriteRecipients';
import { getGroupInfo } from '../services/getGroupInfo';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { action } from 'satcheljs/lib/legacy';
import shouldExpandGroup from 'owa-recipient-common/lib/utils/shouldExpandGroup';

export default action('expandGroup')(async function expandGroup(
    recipientWell: RecipientWellWithFindControlViewState,
    recipientToExpand: ReadWriteRecipientViewState
) {
    recipientToExpand.isExpanding = true;
    let groupResponse = await getGroupInfo(
        recipientToExpand.persona.PersonaId,
        recipientToExpand.persona.ADObjectId,
        recipientToExpand.persona.EmailAddress
    );

    recipientToExpand.isExpanding = false;
    const membersCount =
        groupResponse && groupResponse.MembersCount ? groupResponse.MembersCount : 0;
    let expandedEmails: FindRecipientPersonaType[] = [];
    processGetGroupInfoResult(expandedEmails, groupResponse);

    const shouldExpand: boolean = await shouldExpandGroup(membersCount);

    if (shouldExpand) {
        removeReadWriteRecipients(
            recipientWell,
            [recipientToExpand],
            null /* selectToRight */,
            false
        );
        const recipients = expandedEmails.map(function(recipient: FindRecipientPersonaType) {
            return { isValid: true, newPersona: recipient, newEmailAddress: null };
        });
        addReadWriteRecipients(recipientWell, recipients);
    }
});
